export default __webpack_public_path__ + "static/why-tecalis_03-9e82f29fe397ed791a35e3e81b3a33b9.webp";